import React from 'react';
import Tooltip from 'components/tooltip';
import { ReactComponent as InfoIcon } from 'assets/icons/info.svg';
import { I18n } from 'core';
import CupsHelper from 'assets/images/tarjeta-grafica-tooltip.png';
import styles from './CupsTooltip.module.scss';

const GraficCardContent = (): JSX.Element => (
  <div className={styles.contentGraficCard}>
    <img src={CupsHelper} alt="Grafic Card Helper" width={200} height={200}/>

  </div>
);

const GraficCardTooltip = (): JSX.Element => (
  <Tooltip cursor="help" direction="bottom" content={<GraficCardContent/>}>
    <div className={styles.root}>
      <InfoIcon />
      <p className={styles.label}>{I18n.t('ComunidadesCustomOnboardingProcess.form.labels.tooltipCardOnboarding')}</p>
    </div>
  </Tooltip>
);

export default GraficCardTooltip;
